module.exports = __webpack_public_path__ + "img/DSC_2754-xl.cf6d888a.png";